/**
 * Created by pc on 2019/1/3.
 */
import { post, get } from '../../http/index';
import Page from '@/global/util/Page';
const TRAFFIC_FLOW_TYPE_MENU = 'TRAFFIC_FLOW_TYPE_MENU'; // 媒体来源下拉菜单
const TRAFFIC_DONEWS_PORT_TYPE = 'TRAFFIC_DONEWS_PORT_TYPE'; // 媒体终端类型
const TRAFFIC_MEDIA_MENU = 'TRAFFIC_MEDIA_MENU'; // 媒体类型
const TRAFFIC_MANAGER_TABLE = 'TRAFFIC_MANAGER_TABLE'; // 流量管理表格
const TRAFFIC_DETAILS_TABLE = 'TRAFFIC_DETAILS_TABLE'; // 查看表格
const TRAFFIC_ADVERTISER_PLACE = 'TRAFFIC_ADVERTISER_PLACE'; // 广告位置下拉菜单
const TRAFFIC_ADVERTISER_PLACE_DAUGHTER = 'TRAFFIC_ADVERTISER_PLACE_DAUGHTER'; // 广告位置s所属下拉菜单
const TRAFFIC_ADVERTISER_PLACE_CHANNEL = 'TRAFFIC_ADVERTISER_PLACE_CHANNEL'; // 所属频道下拉菜单
const TRAFFIC_CHANNEL_POSITION_MENU = 'TRAFFIC_CHANNEL_POSITION_MENU'; // 渠道位置菜单
const TRAFFIC_CHANNEL_MENU = 'TRAFFIC_CHANNEL_MENU'; // 渠道菜单
const TRAFFIC_POSITION_MENU = 'TRAFFIC_POSITION_MENU'; // 位置菜单
const TRAFFIC_USER_MENU = 'TRAFFIC_USER_MENU'; // 关联角色
const state = {
  traffic: {
    flowTypeMenu: [],
    curFlowType: '',
    donewsPortTypeMenu: [],
    curDPType: '',
    mediaTypeMenu: [],
    curMedia: '',
    managerPage: new Page(),
    detailsPage: new Page(),
    adpMenu: [],
    curAdp: '',
    adpDaughterMenu: [],
    curAdpDaughter: '',
    adpChannelMenu: [],
    curAdpChannel: '',
    channelMenu: [],
    curChannel: '',
    positionMenu: [],
    curPosition: '',
    userMenu: [],
    curUser: ''
  }
};

const getters = {
  traffic: state => state.traffic
};

const actions = {
  getFlowType ({ commit, state }, { isAll }) {
    get('/interface/etcd/item/flow_type').then(res => {
      if (res.code === 1) {
        commit(TRAFFIC_FLOW_TYPE_MENU, { result: res.data, isAll });
      }
    });
  },
  getDonewsPortType ({ commit, state }, { flowType, media, isAll }) {
    post('/admin/innerFlow/media_option', { flow_type: flowType, media }).then(res => {
      if (res.code === 1) {
        commit(TRAFFIC_DONEWS_PORT_TYPE, { result: res.data.port_type, isAll });
      }
    });
  },
  getMediaType ({ commit, state }, { flowType, isAll }) {
    post('/admin/innerFlow/media_option', { flow_type: flowType }).then(res => {
      if (res.code === 1) {
        commit(TRAFFIC_MEDIA_MENU, { result: res.data.media, isAll });
      }
    });
  },
  async getAdpMenu ({ commit, state }, { params, isAll, api = TRAFFIC_ADVERTISER_PLACE } = {}) {
    await post('/admin/innerFlow/search_type', params).then(res => {
      if (res.code === 1) {
        commit(api, { result: res.data, isAll });
      }
    });
  },
  async getAdpChannel ({ commit, state }, { params, isAll }) {
    await post('/admin/innerFlow/advert_option', params).then(res => {
      if (res.code === 1) {
        commit(TRAFFIC_ADVERTISER_PLACE_CHANNEL, { result: res.data, isAll });
      }
    });
  },
  async getChannelPlace ({ commit, state }, { isAll, params }) {
    await post('/admin/innerFlow/channel_option', params).then(res => {
      if (res.code === 1) {
        commit(TRAFFIC_CHANNEL_POSITION_MENU, { result: res.data, isAll });
      }
    });
  },
  getDonewsChannelMenu ({ commit, state }, { media, portType, isAll }) {
    post('/admin/innerFlow/donews_channel', { media: media, port_type: portType }).then(res => {
      if (res.code === 1) {
        commit(TRAFFIC_CHANNEL_MENU, { result: res.data, isAll });
      }
    });
  },
  getDonewsPositionMenu ({ commit, state }, { params, isAll }) {
    post('/admin/innerFlow/donews_position', params).then(
      res => {
        if (res.code === 1) {
          commit(TRAFFIC_POSITION_MENU, { result: res.data, isAll });
        }
      }
    );
  },
  getUserMenu ({ commit, state }, { isAll } = {}) {
    post('/admin/innerFlow/roleList').then(res => {
      if (res.code === 1) {
        commit(TRAFFIC_USER_MENU, { result: res.data, isAll });
      }
    });
  },
  getTrafficTable (
    { commit, state },
    {
      flowType,
      portType,
      media,
      pageSize = state.traffic.managerPage.pageSize,
      currentPage = state.traffic.managerPage.currentPage
    } = {}
  ) {
    let params = {};
    params.flow_type = flowType;
    params.port_type = portType;
    params.media = media;
    params.page = currentPage;
    params.perpage = pageSize;
    post('/admin/innerFlow/list', params).then(res => {
      if (res.code === 1) {
        commit(TRAFFIC_MANAGER_TABLE, res.data);
      }
    });
  },
  getTrafficDetailsTable (
    { commit, state },
    {
      flowType,
      portType,
      channel,
      media,
      position,
      advertPlace,
      roleId,
      type,
      channelType,
      pageSize = state.traffic.detailsPage.pageSize,
      currentPage = state.traffic.detailsPage.currentPage
    } = {}
  ) {
    let params = {};
    params.flow_type = flowType;
    params.port_type = portType;
    params.media = media;
    if (parseInt(type) === 1) {
      params.advert_place = advertPlace
    } else if (parseInt(type) === 2) {
      params.role_id = roleId
    } else if (parseInt(type) === 3) {
      params.channel_type = channelType
      if (parseInt(channelType) === 1 || parseInt(channelType) === 2) {
        params.channel = channel
      }
      if (parseInt(channelType) !== 0) {
        params.position = position
      }
    }
    params.page = currentPage;
    params.perpage = pageSize;
    get('/admin/innerFlow', params).then(res => {
      if (res.code === 1) {
        commit(TRAFFIC_DETAILS_TABLE, res.data);
      }
    });
  }
};

const mutations = {
  [TRAFFIC_FLOW_TYPE_MENU] (state, result) {
    let arr = {};
    arr.name = '全部流量类型';
    arr.value = '0';
    state.traffic.flowTypeMenu = result.result;
    if (result.isAll) {
      state.traffic.flowTypeMenu.unshift(arr);
    }
    state.traffic.curFlowType = result.result[0].value;
  },
  [TRAFFIC_DONEWS_PORT_TYPE] (state, result) {
    let arr = {};
    arr.name = '全部终端';
    arr.value = '0';
    state.traffic.donewsPortTypeMenu = result.result;
    if (result.isAll) {
      state.traffic.donewsPortTypeMenu.unshift(arr);
    }
    state.traffic.curDPType = result.result[0].value;
  },
  [TRAFFIC_ADVERTISER_PLACE] (state, result) {
    state.traffic.adpMenu = result.result;
    if (!result.isAll) {
      state.traffic.adpMenu = state.traffic.adpMenu.filter(res => {
        if (res.value !== '0') { return res }
      })
    }
    state.traffic.curAdp = state.traffic.adpMenu[0].value;
  },
  [TRAFFIC_ADVERTISER_PLACE_DAUGHTER] (state, result) {
    state.traffic.adpDaughterMenu = result.result;
    if (!result.isAll) {
      state.traffic.adpDaughterMenu = state.traffic.adpDaughterMenu.filter(res => {
        if (res.value !== '0') { return res }
      })
    }
    state.traffic.curAdpDaughter = state.traffic.adpDaughterMenu[0].value;
  },
  [TRAFFIC_ADVERTISER_PLACE_CHANNEL] (state, result) {
    state.traffic.adpChannelMenu = result.result.channel_type
    state.traffic.curAdpChannel = state.traffic.adpChannelMenu.length > 0 ? state.traffic.adpChannelMenu[0].value : ''
    state.traffic.positionMenu = result.result.position;
    state.traffic.curPosition = result.result.position.length > 0 ? result.result.position[0].value : '';
  },
  [TRAFFIC_MEDIA_MENU] (state, result) {
    let arr = {};
    arr.name = '全部媒体';
    arr.value = '0';
    state.traffic.mediaTypeMenu = result.result;
    if (result.isAll) {
      state.traffic.mediaTypeMenu.unshift(arr);
    }
    state.traffic.curMedia = result.result[0].value;
  },
  [TRAFFIC_CHANNEL_POSITION_MENU] (state, result) {
    let arr = {};
    let arr1 = {};
    arr.name = '全部频道';
    arr.value = '0';
    arr1.name = '全部位置';
    arr1.value = '0';
    state.traffic.channelMenu = result.result.channel;
    if (result.isAll) {
      state.traffic.channelMenu.unshift(arr);
    }
    state.traffic.curChannel = result.result.channel.length > 0 ? result.result.channel[0].value : '';
    state.traffic.positionMenu = result.result.position;
    if (result.isAll) {
      state.traffic.positionMenu.unshift(arr1);
    }
    state.traffic.curPosition = result.result.position.length > 0 ? result.result.position[0].value : '';
  },
  [TRAFFIC_CHANNEL_MENU] (state, result) {
    let arr = {};
    arr.name = '全部频道';
    arr.value = '0';
    state.traffic.channelMenu = result.result;
    if (result.isAll) {
      state.traffic.channelMenu.unshift(arr);
    }
    state.traffic.curChannel = result.result[0].value;
  },
  [TRAFFIC_POSITION_MENU] (state, result) {
    let arr = {};
    arr.name = '全部位置';
    arr.value = '0';
    state.traffic.positionMenu = result.result.filter(res => {
      if (res.value !== '0') {
        return res;
      }
    });
    if (result.isAll) {
      state.traffic.positionMenu.unshift(arr);
    }
    state.traffic.curPosition = result.result.length ? result.result[0].value : '';
  },
  [TRAFFIC_USER_MENU] (state, result) {
    let arr = {};
    arr.name = '全部角色';
    arr.value = '0';
    state.traffic.userMenu = result.result;
    if (result.isAll) {
      state.traffic.userMenu.unshift(arr);
    }
    state.traffic.curUser = result.result.length ? result.result[0].value : '';
  },
  [TRAFFIC_MANAGER_TABLE] (state, result) {
    state.traffic.managerPage.setPageData(
      {
        header: result.header,
        data: result.list,
        total: result.count
      },
      false
    );
  },
  [TRAFFIC_DETAILS_TABLE] (state, result) {
    state.traffic.detailsPage.setPageData(
      {
        header: result.header,
        data: result.list,
        total: result.count
      },
      false
    );
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
